import { createContext } from 'react';
import type { ProjectTab } from './ProjectTabs';

export interface ProjectTabContextType {
  activeTab: ProjectTab | null;
  setActiveTab: (tab: ProjectTab, sourceId?: string) => void;
}

/** Separate module so Vite HMR does not recreate the context identity on provider edits. */
export const ProjectTabContext = createContext<ProjectTabContextType | undefined>(undefined);
